module.exports = __webpack_public_path__ + "img/eg-cn-02.bd2c77cb.png";